/*=============================================================================
  VANKEL Heritage — skrypt motywu.
  Web Components + delegacja zdarzen. Bez zaleznosci zewnetrznych.
  Wszystkie teksty pochodza z window.VK.strings (locales), nie z kodu.
=============================================================================*/
(function () {
  'use strict';
  const VK = window.VK || {};
  VK.strings = VK.strings || {};
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  // Waluta i jezyk pochodza ze sklepu (window.VK), nie z kodu.
  const formatMoney = (cents) => {
    const locale = document.documentElement.lang || undefined;
    const opts = { minimumFractionDigits: 0, maximumFractionDigits: 2 };
    if (VK.currencyCode) { opts.style = 'currency'; opts.currency = VK.currencyCode; }
    try {
      return new Intl.NumberFormat(locale, opts).format(cents / 100);
    } catch (e) {
      return new Intl.NumberFormat(locale).format(cents / 100);
    }
  };

  // Ponowne odpalenie tej samej animacji CSS wymaga zdjecia klasy, wymuszenia
  // przeliczenia stylu i nalozenia jej z powrotem — inaczej druga zmiana z rzedu
  // (drugi klik „dodaj do koszyka") nie ruszy niczego. Jeden idiom dla licznika
  // koszyka i dla ceny po zmianie wariantu.
  const vkReplay = (el, cls) => {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  };

  /* ---------- Fokus: pulapka w oknach modalnych, zwrot po podmianie HTML ---------- */
  const VK_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  // tabIndex >= 0 odsiewa tabindex="-1"; getClientRects + visibility dzialaja takze dla
  // elementow position: fixed, dla ktorych offsetParent jest zawsze null.
  const vkFocusables = (box) => $$(VK_FOCUSABLE, box).filter((el) =>
    !el.disabled && el.tabIndex >= 0 && el.getAttribute('aria-hidden') !== 'true' &&
    el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');

  const vkReturnFocus = (el) => {
    if (!el || !el.isConnected || el === document.body || typeof el.focus !== 'function') return;
    // preventScroll, bo pozycje przewijania oddaje tuz przedtem vkUnlockScroll.
    // Bez tego przegladarka „doscrollowuje" do elementu otwierajacego i kasuje
    // przywrocona pozycje — uzytkownik po zamknieciu panelu ladowal na gorze strony.
    // Element i tak jest widoczny: wracamy dokladnie tam, gdzie panel byl otwierany.
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  };

  /* ---------- Blokada przewijania tla ---------- */
  // Licznik, nie flaga. Okien modalnych jest kilka (panel menu, koszyk, tabela
  // rozmiarow, szybki podglad) i potrafia sie na siebie nakladac; pytanie „czy
  // jest otwarte jakies inne okno" wyliczane z nazw klas rozsypuje sie przy
  // kazdym nowym oknie. Samego overflow: hidden Safari na iOS nie honoruje przy
  // przewijaniu dotykiem, wiec <body> idzie na position: fixed (klasy w arkuszu),
  // a zgubiona przez to pozycja przewijania wraca tutaj.
  let vkLocks = 0;
  let vkLockY = 0;
  function vkLockScroll() {
    if (vkLocks++ > 0) return;
    vkLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.top = (-vkLockY) + 'px';
    document.documentElement.classList.add('vk-scroll-locked');
    document.body.classList.add('vk-scroll-locked');
  }
  function vkUnlockScroll() {
    if (!vkLocks) return;
    if (--vkLocks > 0) return;
    document.documentElement.classList.remove('vk-scroll-locked');
    document.body.classList.remove('vk-scroll-locked');
    document.body.style.top = '';
    // Po obrocie ekranu zapamietana pozycja moze wykraczac poza nowa wysokosc dokumentu.
    const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    window.scrollTo(0, Math.min(vkLockY, max));
  }

  // Zapamietuje, na czym stal fokus w kontenerze, ktorego HTML za chwile podmienimy.
  // null = fokus byl poza kontenerem, wiec po podmianie NIE wolno go ruszac.
  function vkCaptureFocus(root) {
    const el = document.activeElement;
    if (!root || !el || el === document.body || !root.contains(el)) return null;
    const qty = el.closest('[data-vk-qty]');
    if (qty) {
      const wrap = qty.closest('.vk-qty');
      const input = wrap ? wrap.querySelector('input[data-vk-line]') : null;
      if (input) return { line: input.dataset.vkLine, dir: qty.dataset.vkQty };
    }
    const rm = el.closest('[data-vk-remove]');
    if (rm) return { line: rm.dataset.vkRemove, remove: true };
    if (el.matches('input[data-vk-line]')) return { line: el.dataset.vkLine, input: true };
    return { any: true };
  }

  // Oddaje fokus temu samemu wierszowi; gdy wiersz zniknal (ilosc 0) — celowi zapasowemu,
  // zeby fokus nigdy nie wracal na <body> (a w oknie modalnym — poza pulapke).
  function vkRestoreFocus(root, mark, fallbackSel) {
    if (!root || !mark) return;
    let target = null;
    const line = mark.line != null ? CSS.escape(String(mark.line)) : null;
    if (line && mark.remove) {
      target = root.querySelector('[data-vk-remove="' + line + '"]');
    } else if (line) {
      const input = root.querySelector('input[data-vk-line="' + line + '"]');
      const wrap = input ? input.closest('.vk-qty') : null;
      target = mark.input ? input : (wrap ? wrap.querySelector('[data-vk-qty="' + mark.dir + '"]') : null);
    }
    if (!target && fallbackSel) target = root.querySelector(fallbackSel);
    if (!target) { root.tabIndex = -1; target = root; }
    target.focus();
  }

  /* ---------- Panel koszyka ---------- */
  class VkCartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-vk-drawer-close]')) { e.preventDefault(); this.close(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('vk:cart:updated', (e) => this.refresh(e.detail));
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-vk-drawer-open]');
        if (t) { e.preventDefault(); this.open(t); }
      });
    }
    open(opener) {
      // Straznik idempotencji: open() bywa wolane przy juz otwartym panelu
      // (po dodaniu do koszyka), a licznik blokady nie wybacza podwojnego wejscia.
      if (this.classList.contains('is-open')) return;
      // Kto otworzyl panel — po zamknieciu fokus wraca dokladnie tam (aria-modal).
      this.vkOpener = opener || document.activeElement;
      this.classList.add('is-open');
      vkLockScroll();
      // Pierwszy w DOM jest przycisk-nakladka; fokus ma isc na zamkniecie w naglowku.
      const first = this.querySelector('.vk-drawer__close') || vkFocusables(this)[0];
      if (first) first.focus();
    }
    close() {
      // Nasluch Escape wisi na dokumencie i odpala takze przy zamknietym panelu —
      // bez tego straznika zabieralibysmy fokus otwartemu modalowi.
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      vkUnlockScroll();
      const back = this.vkOpener;
      this.vkOpener = null;
      vkReturnFocus(back);
    }
    async refresh() {
      // Podmiana innerHTML kasuje element z fokusem — zapamietujemy, na czym stal.
      const mark = vkCaptureFocus(this);
      // Podmiana calej listy to inaczej ciecie i przeskok. aria-busy niesie ten
      // sam komunikat czytnikowi ekranu, wiec jeden atrybut robi obie rzeczy.
      const body = this.querySelector('.vk-drawer__body');
      if (body) body.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(window.location.pathname + '?sections=vk-cart-drawer');
        const data = await res.json();
        const html = new DOMParser().parseFromString(data['vk-cart-drawer'], 'text/html');
        const fresh = html.querySelector('vk-cart-drawer');
        if (!fresh) return;
        this.innerHTML = fresh.innerHTML;
        // Nowa suma trafia do trwalego regionu live POZA podmienianym poddrzewem.
        const status = document.querySelector('[data-vk-cart-status]');
        const total = this.querySelector('.vk-summary__total-value');
        if (status && total) status.textContent = total.textContent.trim();
        // Panel bywa odswiezany dwa razy (zdarzenie + wywolanie wprost). Jesli druga
        // podmiana zniszczyla wezel z fokusem juz po otwarciu, sciagamy fokus z powrotem —
        // inaczej zostaje na <body> pod nakladka, poza pulapka fokusu.
        const lost = this.classList.contains('is-open') && !this.contains(document.activeElement);
        vkRestoreFocus(this, mark || (lost ? { any: true } : null), '.vk-drawer__close');
      } finally {
        // Wezel z atrybutem zniknal razem z podmiana, wiec szukamy go na nowo.
        const back = this.querySelector('.vk-drawer__body');
        if (back) back.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('vk-cart-drawer', VkCartDrawer);

  /* ---------- Panel menu (telefon i tablet) ---------- */
  // Okno modalne, nie „ujawnianie": przykrywa ekran, przechwytuje klikniecia
  // nakladka i blokuje przewijanie tla, wiec musi miec caly kontrakt dialogu —
  // pulapke fokusu, Escape i zwrot fokusu. Pulapki nie piszemy drugi raz:
  // globalny handler Tab nizej obejmuje takze `vk-menu-drawer.is-open`.
  class VkMenuDrawer extends HTMLElement {
    connectedCallback() {
      // Ta sama liczba i ten sam operator co w arkuszu (@media max-width: 1080px).
      // Rozjazd o 1px zostawialby szczeline, w ktorej panel stoi otwarty nad
      // dzialajacym mega-menu, a przycisk zamkniecia jest juz display: none.
      this.mq = window.matchMedia('(max-width: 1080px)');
      this.onMq = (e) => { if (!e.matches) this.close(true); };
      this.onKey = (e) => {
        if (e.key !== 'Escape' || !this.classList.contains('is-open')) return;
        // Okno otwarte nad panelem ma pierwszenstwo i wlasna obsluge Escape.
        if ($('.vk-modal.is-open') || $('vk-cart-drawer.is-open')) return;
        this.close();
      };
      // Powrot gestem Wstecz w iOS przywraca strone z bfcache dokladnie w stanie
      // sprzed wyjscia — z otwartym panelem i zalozona blokada przewijania.
      this.onShow = (e) => { if (e.persisted) this.close(true); };
      this.onDoc = (e) => {
        const opener = e.target.closest('[data-vk-menu-open]');
        if (opener) { e.preventDefault(); this.open(opener); return; }
        // Dwa okna modalne nigdy nie stoja naraz.
        if (e.target.closest('[data-vk-drawer-open]')) this.close();
      };
      this.mq.addEventListener('change', this.onMq);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('pageshow', this.onShow);
      document.addEventListener('click', this.onDoc);
      // Delegacja na samym komponencie — jeden nasluch na zamkniecie,
      // przelaczniki podmenu i nawigacje linkiem.
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-vk-menu-close]')) { e.preventDefault(); this.close(); return; }
        const toggle = e.target.closest('[data-vk-menu-toggle]');
        if (toggle) { e.preventDefault(); this.toggleSub(toggle); return; }
        // Link do biezacego adresu albo kotwica nie przeladuje strony, wiec panel
        // zostalby otwarty nad celem. Przy prawdziwej nawigacji close() jest
        // nieszkodliwe. Warunek na target pomija linki otwierane w nowej karcie.
        const a = e.target.closest('a[href]');
        if (a && !a.target) this.close();
      });
    }
    disconnectedCallback() {
      // Edytor motywu podmienia sekcje w locie. Bez tego blokada przewijania
      // zostalaby na stronie, a nasluchy na dokumencie by sie nawarstwialy.
      this.mq.removeEventListener('change', this.onMq);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('pageshow', this.onShow);
      document.removeEventListener('click', this.onDoc);
      this.close(true);
    }
    open(opener) {
      if (this.classList.contains('is-open')) return;
      // Kto otworzyl panel — po zamknieciu fokus wraca dokladnie tam.
      this.vkOpener = opener || document.activeElement;
      this.classList.add('is-open');
      vkLockScroll();
      this.syncOpeners('true');
      // NIE fokusujemy pola wyszukiwania: klawiatura ekranowa zabralaby polowe
      // ekranu przy kazdym otwarciu menu. Fokus idzie na zamkniecie, jak w koszyku.
      const first = this.querySelector('.vk-drawer__close') || vkFocusables(this)[0];
      if (first) first.focus();
    }
    close(force) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      vkUnlockScroll();
      // Panel wraca zwiniety — inaczej po ponownym otwarciu uzytkownik dostaje
      // kontekst sprzed nawigacji.
      this.collapseAll();
      this.syncOpeners('false');
      const back = this.vkOpener;
      this.vkOpener = null;
      if (force) {
        // Wyjscie na desktop, bfcache albo przeladowanie sekcji: przycisk
        // otwierajacy jest juz display: none, a focus() na nim cicho nic nie robi
        // i fokus spadlby na <body>. Ruszamy go tylko wtedy, gdy naprawde siedzi
        // w panelu, i bez przewijania — inaczej strona skakalaby na gore.
        if (!this.contains(document.activeElement)) return;
        const main = document.getElementById('MainContent');
        if (!main) return;
        try { main.focus({ preventScroll: true }); } catch (err) { main.focus(); }
        return;
      }
      vkReturnFocus(back);
    }
    setSub(btn, open) {
      const sub = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(open));
      if (sub) sub.classList.toggle('is-open', open);
    }
    toggleSub(btn) {
      const sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      const open = !sub.classList.contains('is-open');
      // Akordeon jednootwarciowy w obrebie poziomu: kilka rozwinietych galezi
      // zamienia panel na telefonie w dlugie przewijanie i gubi punkt odniesienia.
      if (open) {
        const scope = btn.closest('.vk-menu__sublist') || this;
        $$('[data-vk-menu-toggle][aria-expanded="true"]', scope).forEach((b) => this.setSub(b, false));
      }
      this.setSub(btn, open);
    }
    collapseAll() {
      $$('[data-vk-menu-toggle][aria-expanded="true"]', this).forEach((b) => this.setSub(b, false));
    }
    // aria-expanded przycisku w pasku musi zejsc takze przy zamknieciu wymuszonym.
    syncOpeners(state) {
      $$('[data-vk-menu-open][aria-controls="' + this.id + '"]').forEach((b) => b.setAttribute('aria-expanded', state));
    }
  }
  customElements.define('vk-menu-drawer', VkMenuDrawer);

  /* ---------- Formularz dodania do koszyka ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-vk-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    // Etykieta siedzi w <span> (regula .vk-btn--cta > span) — podmieniamy jego tresc,
    // nie calego przycisku, zeby nie skasowac wymaganego wezla.
    const labelEl = btn ? (btn.querySelector('span') || btn) : null;
    const label = labelEl ? labelEl.textContent : '';
    const box = form.querySelector('[data-vk-form-error]');
    // Nowa proba = czysty komunikat; inaczej stary blad zostaje po udanym dodaniu.
    if (box) { box.hidden = true; box.textContent = ''; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); labelEl.textContent = VK.strings.adding || '…'; }
    try {
      const body = new FormData(form);
      body.append('sections', 'vk-cart-drawer');
      const res = await fetch(VK.routes.cart_add, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const json = await res.json();
      if (json.status) throw new Error(json.description || VK.strings.error);
      document.dispatchEvent(new CustomEvent('vk:cart:updated', { detail: json }));
      updateCartCount();
      if (VK.cartType === 'drawer') { const d = $('vk-cart-drawer'); if (d) { await d.refresh(); d.open(); } }
      else { window.location.href = VK.routes.cart; }
    } catch (err) {
      // Czytnik ekranu ma to oglosic — role i aria-live ustawiamy stad, zeby sekcje
      // nie musialy o tym pamietac. Tekst wpisujemy dopiero po odslonieciu regionu,
      // inaczej tresc wstawiona razem z rola bywa pomijana.
      if (box) {
        box.setAttribute('role', 'alert');
        box.setAttribute('aria-live', 'assertive');
        box.hidden = false;
        window.setTimeout(() => { box.textContent = err.message; }, 60);
      }
    } finally {
      if (btn) { btn.removeAttribute('aria-disabled'); labelEl.textContent = label; }
    }
  });

  async function updateCartCount() {
    const res = await fetch(VK.routes.cart + '.js');
    const cart = await res.json();
    $$('[data-vk-cart-count]').forEach((el) => {
      const next = String(cart.item_count);
      // Animujemy wylacznie ZMIANE. Przy tej samej liczbie (odswiezenie panelu
      // bez dodania pozycji) licznik ma stac spokojnie.
      const changed = el.textContent.trim() !== next;
      el.textContent = next;
      if (changed) vkReplay(el, 'is-bumped');
    });
    $$('[data-vk-shipbar]').forEach((el) => paintShipBar(el, cart.total_price));
  }

  function paintShipBar(root, total) {
    const threshold = VK.freeShippingThreshold || 0;
    if (!threshold) return;
    const bar = root.querySelector('[data-vk-shipbar-bar]');
    const msg = root.querySelector('[data-vk-shipbar-msg]');
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    // --vk-progress zamiast style.width: arkusz skaluje pasek transformem, wiec
    // napelnianie idzie w kompozytorze zamiast przeliczac uklad w kazdej klatce.
    if (bar) bar.style.setProperty('--vk-progress', (pct / 100).toFixed(3));
    if (msg) {
      const left = Math.max(0, threshold - total);
      msg.textContent = left > 0
        ? (msg.dataset.remaining || '').replace('[amount]', formatMoney(left))
        : (msg.dataset.reached || '');
    }
  }

  /* ---------- Ilosc w koszyku ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-vk-qty]');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest('.vk-qty');
    const input = wrap.querySelector('input');
    const step = btn.dataset.vkQty === 'up' ? 1 : -1;
    // Minimum to 1 — usuwanie pozycji ma wlasny przycisk [data-vk-remove].
    const next = Math.max(1, parseInt(input.value, 10) + step);
    input.value = next;
    if (input.dataset.vkLine) await changeLine(input.dataset.vkLine, next);
  });

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-vk-remove]');
    if (!rm) return;
    e.preventDefault();
    await changeLine(rm.dataset.vkRemove, 0);
  });

  // Panel koszyka jest renderowany przez {% section %} w layoutcie, wiec jego ID to nazwa
  // pliku. Sekcja koszyka na stronie siedzi w szablonie JSON i ma wlasne ID ("main").
  function sectionsToRefresh() {
    const root = $('[data-vk-cart-root]');
    const sid = root ? root.dataset.vkSectionId : null;
    return sid ? 'vk-cart-drawer,' + sid : 'vk-cart-drawer';
  }

  async function changeLine(line, quantity) {
    const cartRoot = $('[data-vk-cart-root]');
    // Przycisk, ktory wlasnie klikneto, zniknie razem z podmienianym HTML sekcji.
    const mark = vkCaptureFocus(cartRoot);
    const res = await fetch(VK.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionsToRefresh() })
    });
    const json = await res.json();
    const cartSid = cartRoot ? cartRoot.dataset.vkSectionId : null;
    if (cartSid && json.sections && json.sections[cartSid]) {
      const doc = new DOMParser().parseFromString(json.sections[cartSid], 'text/html');
      const fresh = doc.querySelector('[data-vk-cart-root]');
      if (fresh && cartRoot) {
        cartRoot.innerHTML = fresh.innerHTML;
        vkRestoreFocus(cartRoot, mark, '[data-vk-qty]');
      }
    }
    document.dispatchEvent(new CustomEvent('vk:cart:updated', { detail: json }));
    updateCartCount();
  }

  /* ---------- Galeria produktu ---------- */
  class VkGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-vk-thumb]');
        if (!thumb) return;
        e.preventDefault();
        this.select(thumb.dataset.vkThumb);
      });
      document.addEventListener('vk:variant:changed', (e) => {
        if (e.detail && e.detail.mediaId) this.select(e.detail.mediaId);
      });
      this.initZoom();
    }
    select(id) {
      $$('[data-vk-thumb]', this).forEach((t) => t.setAttribute('aria-current', String(t.dataset.vkThumb === id)));
      $$('[data-vk-slide]', this).forEach((s) => s.classList.toggle('is-active', s.dataset.vkSlide === id));
    }
    initZoom() {
      const stage = this.querySelector('[data-vk-stage]');
      if (!stage) return;
      // Sledzenie kursora tylko tam, gdzie ma sens: jest hover I uzytkownik nie prosil
      // o ograniczenie ruchu. W pozostalych wypadkach zostaje statyczne przyblizenie
      // na stuknięcie — wczesniej ten handler byl martwy, bo funkcja wychodzila wyzej.
      const rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hover = window.matchMedia('(hover: hover)');
      const live = () => hover.matches && !rm.matches;
      // getBoundingClientRect() w KAZDYM zdarzeniu mousemove (100+/s) to
      // wymuszony reflow na kazde zdarzenie. Zapisujemy same wspolrzedne,
      // a prostokat mierzymy raz na klatke.
      let zRaf = null;
      let zx = 0;
      let zy = 0;
      const paintOrigin = () => {
        zRaf = null;
        const r = stage.getBoundingClientRect();
        if (!r.width || !r.height) return;
        stage.style.setProperty('--ox', ((zx - r.left) / r.width * 100).toFixed(2) + '%');
        stage.style.setProperty('--oy', ((zy - r.top) / r.height * 100).toFixed(2) + '%');
      };
      const queueOrigin = (e) => {
        zx = e.clientX;
        zy = e.clientY;
        if (zRaf) return;
        zRaf = requestAnimationFrame(paintOrigin);
      };
      const cancelOrigin = () => {
        if (!zRaf) return;
        cancelAnimationFrame(zRaf);
        zRaf = null;
      };
      stage.addEventListener('mouseenter', () => { if (live()) stage.classList.add('is-zoom'); });
      stage.addEventListener('mouseleave', () => {
        if (!live()) return;
        // Anulujemy zaplanowana klatke, inaczej nadpisze przywrocony srodek.
        cancelOrigin();
        stage.classList.remove('is-zoom');
        stage.style.setProperty('--ox', '50%');
        stage.style.setProperty('--oy', '50%');
      });
      stage.addEventListener('mousemove', (e) => {
        if (!live()) return;
        queueOrigin(e);
      });
      // Brak hover albo ograniczony ruch: stuknięcie przełącza statyczne przybliżenie.
      stage.addEventListener('click', (e) => {
        if (live()) return;
        stage.classList.toggle('is-zoom');
        queueOrigin(e);
      });
    }
  }
  customElements.define('vk-gallery', VkGallery);

  /* ---------- Wybor wariantu ---------- */
  class VkVariants extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.addEventListener('change', () => this.onChange());
    }
    onChange() {
      const chosen = $$('input[type="radio"]:checked, select', this).map((i) => i.value);
      const variant = this.data.find((v) => v.options.every((o, i) => o === chosen[i]));
      // Wybor wariantu i przycisk zakupu to OSOBNE bloki sekcji produktu, wiec
      // <vk-variants> nie lezy w <form>. Formularza szukamy w calej karcie produktu.
      const scope = this.closest('[data-vk-product]') || document;
      const form = scope.querySelector('[data-vk-add-form]');
      const idField = form ? form.querySelector('[name="id"]') : null;
      const btn = form ? form.querySelector('[type="submit"]') : null;
      // Etykieta przycisku siedzi w <span> — podmieniamy jego tresc, nie calego przycisku.
      const btnLabel = btn ? (btn.querySelector('span') || btn) : null;
      $$('[data-vk-option-label]', this).forEach((el) => {
        const idx = parseInt(el.dataset.vkOptionLabel, 10);
        if (chosen[idx]) el.textContent = chosen[idx];
      });
      if (!variant) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = VK.strings.unavailable; }
        return;
      }
      if (idField) idField.value = variant.id;
      if (btn) {
        btn.removeAttribute('aria-disabled');
        btnLabel.textContent = variant.available ? VK.strings.addToCart : VK.strings.soldOut;
        if (!variant.available) btn.setAttribute('aria-disabled', 'true');
      }
      const price = scope.querySelector('[data-vk-price]');
      if (price && variant.price != null) {
        // Podmieniamy tylko sama kwote — nadpisanie innerHTML kasowalo przekreslona
        // cene i plakietke przeceny wyrenderowane przez snippets/vk-price.liquid.
        const now = price.querySelector('.vk-price__now');
        const before = now ? now.textContent : price.textContent;
        if (now) now.textContent = formatMoney(variant.price); else price.textContent = formatMoney(variant.price);
        // Sygnal, ze kwota sie zmienila — dotad podmiana szla bez slowa.
        if ((now ? now.textContent : price.textContent) !== before) vkReplay(price, 'is-changed');
        const was = price.querySelector('.vk-price__was');
        const off = price.querySelector('.vk-price__off');
        const onSale = variant.compare_at_price > variant.price;
        if (was) {
          was.hidden = !onSale;
          if (onSale) was.textContent = formatMoney(variant.compare_at_price);
        }
        if (off) {
          off.hidden = !onSale;
          if (onSale && VK.strings.savePercent) {
            const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            off.textContent = VK.strings.savePercent.replace('[percent]', pct);
          }
        }
      }
      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('vk:variant:changed', { detail: { variant: variant, mediaId: variant.featured_media_id ? String(variant.featured_media_id) : null } }));
    }
  }
  customElements.define('vk-variants', VkVariants);

  /* ---------- Mega-menu: odrzucenie klawiatura ---------- */
  // Panel otwiera sie na hover i focus-within. WCAG 1.4.13 wymaga, zeby dalo sie go
  // schowac bez ruszania kursora ani fokusu — Escape ustawia klase, ktora go gasi.
  const vkMegaItems = () => $$('.vk-nav__item').filter((it) => it.querySelector('.vk-mega'));
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    // Modal i panel koszyka maja wlasna obsluge Escape i pierwszenstwo.
    if ($('.vk-modal.is-open') || $('vk-cart-drawer.is-open') || $('vk-menu-drawer.is-open')) return;
    vkMegaItems().forEach((it) => {
      if (!it.matches(':hover') && !it.contains(document.activeElement)) return;
      it.classList.add('is-dismissed');
      // Fokus schodzi z wnetrza panelu na sama zakladke, inaczej zostalby w ukrytej tresci.
      const link = it.querySelector('.vk-nav__link');
      if (link && it.contains(document.activeElement)) link.focus();
    });
  });
  // mouseleave nie bakluje — lapiemy je w fazie przechwytywania.
  document.addEventListener('mouseleave', (e) => {
    const it = e.target instanceof Element ? e.target.closest('.vk-nav__item') : null;
    if (it) it.classList.remove('is-dismissed');
  }, true);
  document.addEventListener('focusout', (e) => {
    const it = e.target instanceof Element ? e.target.closest('.vk-nav__item') : null;
    if (!it) return;
    setTimeout(() => { if (!it.contains(document.activeElement)) it.classList.remove('is-dismissed'); }, 0);
  });

  /* ---------- Rekomendacje produktow ---------- */
  // Obiekt `recommendations` wypelnia sie WYLACZNIE na trasie product_recommendations_url,
  // wiec sekcja renderuje najpierw pusty placeholder i dociaga swoja tresc stad.
  $$('[data-vk-recommendations]').forEach(async (el) => {
    const url = el.dataset.url;
    if (!url) return;
    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('.vk-section');
      if (!fresh) { el.remove(); return; }
      // Doladowana tresc omija obserwator wejscia — pokazujemy ja od razu.
      $$('.vk-reveal, .vk-stagger', fresh).forEach((n) => n.classList.add('is-in'));
      el.replaceWith(fresh);
    } catch (e) {
      el.remove();
    }
  });

  /* ---------- Adresy klienta: kraj -> wojewodztwo ---------- */
  // Shopify wypelnia <option data-provinces="[[kod,nazwa],...]"> w all_country_option_tags.
  // Komponent przepisuje te liste do drugiego selecta i chowa go dla krajow bez podzialu.
  class VkAddressForm extends HTMLElement {
    connectedCallback() {
      this.country = this.querySelector('[data-vk-address-country]');
      this.province = this.querySelector('[data-vk-address-province]');
      this.wrap = this.querySelector('[data-vk-address-province-wrap]');
      if (!this.country || !this.province || !this.wrap) return;
      if (this.country.dataset.default) this.country.value = this.country.dataset.default;
      this.country.addEventListener('change', () => this.sync());
      this.sync(this.province.dataset.default);
    }
    sync(preselect) {
      const opt = this.country.selectedOptions[0];
      let list = [];
      if (opt && opt.dataset.provinces) {
        try { list = JSON.parse(opt.dataset.provinces); } catch (e) { list = []; }
      }
      this.wrap.hidden = list.length === 0;
      this.province.innerHTML = '';
      list.forEach((pair) => {
        const o = document.createElement('option');
        o.value = pair[0];
        o.textContent = pair[1];
        this.province.appendChild(o);
      });
      if (preselect) this.province.value = preselect;
    }
  }
  customElements.define('vk-address-form', VkAddressForm);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vk-address-delete]');
    if (!btn) return;
    if (!window.confirm(btn.dataset.confirmMessage)) e.preventDefault();
  });

  /* ---------- Filtry kolekcji (Search & Discovery) ---------- */
  class VkFacets extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        if (e.target.matches('input, select')) this.apply();
      });
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-vk-facets-toggle]');
        if (t) {
          e.preventDefault();
          const p = this.querySelector('[data-vk-facets-panel]');
          if (p) { const open = p.classList.toggle('is-open'); t.setAttribute('aria-expanded', String(open)); }
        }
      });
    }
    async apply() {
      const form = this.querySelector('form');
      // Section Rendering API adresuje sekcje po ID z szablonu (zwykle "main"),
      // nie po nazwie pliku — sekcja podaje je w data-vk-section-id.
      const sid = this.dataset.vkSectionId;
      if (!form || !sid) return;
      const params = new URLSearchParams(new FormData(form)).toString();
      const url = window.location.pathname + '?' + params;
      // Co bylo zaznaczone przed podmiana, zeby oddac fokus po przerysowaniu filtrow.
      const active = document.activeElement;
      const activeName = active && active.name ? active.name : null;
      const activeValue = active && active.value != null ? active.value : null;
      // Miedzy klikiem w filtr a podmiana siatki nie dzialo sie nic — czesc
      // klientow klikala chip drugi raz i tym samym odznaczala filtr.
      // pointer-events: none z arkusza zabezpiecza przed tym takze mechanicznie.
      const grid = document.querySelector('[data-vk-product-grid]');
      if (grid) grid.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(url + '&sections=' + encodeURIComponent(sid));
        const json = await res.json();
        if (!json || typeof json[sid] !== 'string') return;
        const doc = new DOMParser().parseFromString(json[sid], 'text/html');
        // Podmieniamy CALY kontener wynikow, nie sama siatke: przy zerze wynikow
        // swiezy dokument nie ma [data-vk-product-grid], wiec straznik nie wykonywal
        // podmiany i na ekranie zostawaly stare produkty przy liczniku 0.
        ['[data-vk-collection-results]', '[data-vk-collection-count]', '[data-vk-facets-form]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        // Doladowana siatka omija obserwator wejscia — bez tego zostalaby na opacity: 0.
        $$('[data-vk-collection-results] .vk-reveal, [data-vk-collection-results] .vk-stagger')
          .forEach((n) => n.classList.add('is-in'));
        if (activeName) {
          const back = this.querySelector('[name="' + CSS.escape(activeName) + '"][value="' + CSS.escape(activeValue) + '"]')
            || this.querySelector('[name="' + CSS.escape(activeName) + '"]');
          if (back) back.focus();
        }
        if (window.history.replaceState) window.history.replaceState({}, '', url);
      } catch (e) {
        window.location.href = url;
      } finally {
        // Siatka mogla zostac podmieniona — atrybut zdejmujemy ze swiezego wezla.
        const back = document.querySelector('[data-vk-product-grid]');
        if (back) back.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('vk-facets', VkFacets);

  /* ---------- Zakladki (obsluga klienta, logowanie) ---------- */
  const vkTabsOf = (root) => $$('[data-vk-tab]', root);

  function vkActivateTab(btn, focus) {
    const root = btn.closest('[data-vk-tabs]') || document;
    // Roving tabindex: caly pasek zakladek to jeden przystanek Tab (wzorzec ARIA tablist).
    vkTabsOf(root).forEach((b) => {
      const on = b === btn;
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    $$('[data-vk-tabpanel]', root).forEach((p) => { p.hidden = p.dataset.vkTabpanel !== btn.dataset.vkTab; });
    if (focus) btn.focus();
  }

  $$('[data-vk-tabs]').forEach((root) => {
    const tabs = vkTabsOf(root);
    if (!tabs.length) return;
    const selected = tabs.filter((b) => b.getAttribute('aria-selected') === 'true')[0] || tabs[0];
    tabs.forEach((b) => { b.tabIndex = b === selected ? 0 : -1; });
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vk-tab]');
    if (btn) vkActivateTab(btn);
  });

  // Strzalki w poziomie plus Home/End — panele pokazuja sie natychmiast, wiec
  // stosujemy aktywacje automatyczna (ARIA APG, wzorzec tabs).
  document.addEventListener('keydown', (e) => {
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    const btn = e.target && e.target.closest ? e.target.closest('[data-vk-tab]') : null;
    if (!btn) return;
    const tabs = vkTabsOf(btn.closest('[data-vk-tabs]') || document);
    const at = tabs.indexOf(btn);
    if (at < 0 || tabs.length < 2) return;
    let next = -1;
    if (e.key === 'ArrowRight') next = (at + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (at - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    if (next < 0) return;
    e.preventDefault();
    vkActivateTab(tabs[next], true);
  });

  /* ---------- Logowanie: stary link /account/login#recover ---------- */
  // Shopify wysyla w mailach transakcyjnych link z #recover — otwieramy wtedy
  // zakladke odzyskiwania hasla, chyba ze wlasnie pokazujemy potwierdzenie wyslania.
  // Wolamy vkActivateTab wprost: syntetyczny click przed rejestracja nasluchu
  // (a ta jest wyzej dopiero od tej wersji) przelatywal w prozni.
  const recoverTab = $('[data-vk-tabs] [data-vk-tab="recover"]');
  if (recoverTab && window.location.hash === '#recover' && !$('[data-vk-recover-success]')) {
    vkActivateTab(recoverTab);
  }

  /* ---------- Modale (tabela rozmiarow, szybki podglad) ---------- */
  // Zamykanie dziala na najblizszym .vk-modal, nie na sztywno na modalu rozmiarow —
  // inaczej przycisk zamkniecia w szybkim podgladzie gasil niewlasciwe okno.
  let vkModalOpener = null;

  function openModal(modal, opener) {
    if (!modal) return;
    // Straznik idempotencji — patrz vkLockScroll.
    if (modal.classList.contains('is-open')) return;
    // Przy oknie otwartym nad oknem nie nadpisujemy pierwotnego triggera.
    if (!$('.vk-modal.is-open')) vkModalOpener = opener || document.activeElement;
    modal.classList.add('is-open');
    vkLockScroll();
    // Pierwszy [data-vk-size-close] w DOM to przycisk-nakladka; fokus ma isc na
    // zamkniecie w rogu panelu.
    const first = modal.querySelector('.vk-modal__close') || vkFocusables(modal)[0];
    if (first) first.focus();
  }
  function closeModal(modal) {
    // Straznik: Escape leci na dokumencie, wiec funkcja bywa wolana dla zamknietego okna.
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    vkUnlockScroll();
    if ($('.vk-modal.is-open')) return;
    const back = vkModalOpener;
    vkModalOpener = null;
    vkReturnFocus(back);
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-vk-size-open]');
    if (opener) {
      e.preventDefault();
      openModal($('[data-vk-size-modal]'), opener);
      return;
    }
    const closer = e.target.closest('[data-vk-size-close]');
    if (closer) closeModal(closer.closest('.vk-modal'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.vk-modal.is-open').forEach((m) => closeModal(m));
  });

  // Pulapka fokusu: przy aria-modal="true" Tab i Shift+Tab musza krazyc w obrebie
  // otwartego okna. Szuflada stoi w layoutcie przed modalami, wiec ostatnie pudelko
  // w kolejnosci dokumentu jest tym wierzchnim.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const boxes = $$('.vk-modal.is-open, vk-cart-drawer.is-open, vk-menu-drawer.is-open');
    if (!boxes.length) return;
    const inside = boxes.filter((b) => b.contains(document.activeElement));
    const box = inside[inside.length - 1] || boxes[boxes.length - 1];
    const items = vkFocusables(box);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    // Fokus wyciekl poza okno (np. po podmianie HTML) — sciagamy go z powrotem.
    if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Naglowek nalozony na hero ---------- */
  // Stan „pelne tlo" wlacza wartownik przy dolnej krawedzi hero, a nie nasluch
  // przewijania: IntersectionObserver budzi sie tylko przy przecieciu progu,
  // wiec samo przewijanie nie kosztuje ani jednej klatki pracy.
  // Wysokosc naglowka idzie do --vk-header-h — czytaja ja wartownik (swoja
  // wysokosc), hero (doliczona wysokosc, padding tresci i gradient) oraz
  // scroll-padding-top dla kotwic. Sam UKLAD nie zalezy od tego skryptu:
  // zdejmuje naglowek z toku arkusz (wrapper o zerowej wysokosci), wiec brak
  // JS nie daje ani przeskoku, ani blysku zlego stanu.
  (function headerOverlay() {
    let hdr = $('[data-vk-header]');
    if (!hdr) return;                        // podglad pojedynczej sekcji w edytorze
    const root = document.documentElement;

    let lastH = -1;
    let ro = null;
    const measure = () => {
      // Edytor motywu podmienia zawartosc sekcji na nowy DOM. Bez ponownego
      // pobrania mierzylibysmy odlaczony wezel (wysokosc 0) i --vk-header-h
      // zostawaloby nieaktualne az do przeladowania.
      hdr = $('[data-vk-header]') || hdr;
      const h = Math.round(hdr.getBoundingClientRect().height);
      // ResizeObserver potrafi odpalac przy niezmienionej wysokosci — bez tego
      // straznika kazde wywolanie pisaloby do stylu i uniewazniało uklad.
      if (!h || h === lastH) return;
      lastH = h;
      root.style.setProperty('--vk-header-h', h + 'px');
    };
    const observeHeader = () => {
      if (!('ResizeObserver' in window)) return;
      if (ro) ro.disconnect();
      ro = new ResizeObserver(measure);
      ro.observe(hdr);
    };
    measure();
    observeHeader();

    const solid = (on) => document.body.classList.toggle('vk-body--header-solid', on);
    const past = (s) => s.getBoundingClientRect().top <= 0;

    let io = null;
    let raf = null;
    let onScroll = null;
    const stopScroll = () => {
      if (!onScroll) return;
      window.removeEventListener('scroll', onScroll);
      onScroll = null;
    };

    const bind = () => {
      if (io) { io.disconnect(); io = null; }
      stopScroll();
      measure();
      observeHeader();
      const sentinel = $('[data-vk-hero-sentinel]');
      // Brak wartownika = na tej stronie nie ma hero z nalozeniem. Skora zalezy
      // i tak od warunku :has() w arkuszu, wiec klasa jest wtedy bezczynna.
      if (!sentinel) { solid(false); return; }
      solid(past(sentinel));                 // wejscie z kotwica albo z odtworzonej pozycji
      if ('IntersectionObserver' in window) {
        // Wartownik ma WYSOKOSC naglowka, wiec prog 1 („przestal byc widoczny
        // w calosci") wypada dokladnie wtedy, gdy dol hero dochodzi do dolnej
        // krawedzi paska. Prog 0 domyka przypadek hero nizszego od okna.
        // Predykat jest ten sam w obie strony — zadnej histerezy do wymyslania.
        io = new IntersectionObserver((entries) => {
          solid(entries[entries.length - 1].boundingClientRect.top <= 0);
        }, { threshold: [0, 1] });
        io.observe(sentinel);
        return;
      }
      // Zapas dla kontekstow bez IO: jedno wyliczenie na klatke, nie na zdarzenie.
      onScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = null; solid(past(sentinel)); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    };

    bind();
    // Powrot gestem Wstecz (bfcache) przywraca pozycje przewijania bez zdarzenia
    // obserwatora — stan trzeba przeliczyc recznie.
    window.addEventListener('pageshow', bind);
    window.addEventListener('resize', () => {
      measure();
      const sentinel = $('[data-vk-hero-sentinel]');
      if (sentinel) solid(past(sentinel));
    }, { passive: true });
    // Edytor motywu podmienia i przestawia sekcje w locie: wartownik moze
    // zniknac, wrocic albo przestac byc pierwsza sekcja.
    document.addEventListener('shopify:section:load', () => { lastH = -1; measure(); bind(); });
    document.addEventListener('shopify:section:unload', bind);
    document.addEventListener('shopify:section:reorder', bind);
  })();

  /* ---------- Rotujacy pasek informacyjny ---------- */
  // Komunikaty moga zawierac linki, wiec rotacja nie moze byc bezwarunkowa:
  // przy prefers-reduced-motion stoi, a najechanie mysza albo wejscie fokusem
  // w pasek ja wstrzymuje (WCAG 2.2.2).
  // Preferencja jest czytana NA ZYWO (nasluch 'change'), a nie raz przy starcie:
  // wlaczenie redukcji ruchu w trakcie sesji ma zatrzymac rotacje natychmiast.
  // Ten sam wzorzec ma juz lupa PDP.
  const rotator = $('[data-vk-rotator]');
  if (rotator) {
    const msgs = $$('.vk-util__msg', rotator);
    if (msgs.length > 1) {
      const rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      const delay = parseInt(rotator.dataset.vkRotator, 10) || 4500;
      let i = 0;
      let timer = null;
      const tick = () => {
        // Nigdy nie chowamy komunikatu trzymajacego fokus — fokus spadlby na <body>.
        if (rotator.contains(document.activeElement)) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      };
      const stop = () => { if (timer) { window.clearInterval(timer); timer = null; } };
      const start = () => {
        if (rm && rm.matches) return;
        if (!timer) timer = window.setInterval(tick, delay);
      };
      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', (e) => {
        if (!rotator.contains(e.relatedTarget)) start();
      });
      if (rm && rm.addEventListener) {
        rm.addEventListener('change', (e) => { if (e.matches) stop(); else start(); });
      }
      start();
    }
  }

  /* ---------- Szybki podglad ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-vk-quick-view]');
    // Straznik na aria-busy: bez niego drugi klik w trakcie pobierania wysylal
    // drugie zadanie i otwieral modal dwa razy.
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const modal = $('[data-vk-quick-modal]');
    if (!modal) return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(btn.dataset.vkQuickView + '?section_id=vk-quick-view');
      if (!res.ok) throw new Error(String(res.status));
      modal.querySelector('[data-vk-quick-body]').innerHTML = await res.text();
      openModal(modal, btn);
    } catch (err) {
      // Puste okno jest gorsze niz brak okna — schodzimy na pelna karte produktu.
      window.location.href = btn.dataset.vkQuickView;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  /* ---------- Wejscie sekcji w kadr ---------- */
  (function reveal() {
    const rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    const reduce = (rm && rm.matches) || VK.reveal === false;
    const nodes = () => $$('.vk-reveal:not(.is-in), .vk-stagger:not(.is-in)');
    const showAll = () => nodes().forEach((el) => el.classList.add('is-in'));
    // Preferencja czytana na zywo, tak samo jak w rotatorze i w lupie PDP.
    // Stany poczatkowe gasi juz sam arkusz (blok reduce), ale klasy `is-in`
    // maja isc razem z nimi, zeby stan DOM nie rozjezdzal sie ze stanem CSS.
    if (rm && rm.addEventListener) rm.addEventListener('change', (e) => { if (e.matches) showAll(); });
    if (reduce || !('IntersectionObserver' in window) || !('requestAnimationFrame' in window)) { showAll(); return; }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    // Obserwator to sciezka glowna; nasluch przewijania to niezalezne zabezpieczenie —
    // w osadzonym kontekscie (podglad, iframe) callback IO potrafi nie odpalic,
    // a sam test prostokata nigdy nie zostawi sekcji na opacity: 0.
    const scan = () => {
      const pending = nodes();
      // Sekcje leza w kolejnosci dokumentu, wiec po pierwszej ponizej progu
      // reszta jest tym bardziej ponizej — dalsze pomiary sa tylko kolejnymi
      // wymuszonymi reflow na klatke przewijania. io.observe() nie mierzy nic,
      // wiec obserwacja zostaje pelna.
      let below = false;
      pending.forEach((el) => {
        if (!el.dataset.vkObserved) { el.dataset.vkObserved = '1'; io.observe(el); }
        if (below) return;
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('is-in');
        else below = true;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    };

    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; scan(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Sekcje doladowane przez Section Rendering API
    document.addEventListener('vk:cart:updated', scan);
    document.addEventListener('shopify:section:load', () => {
      window.addEventListener('scroll', onScroll, { passive: true });
      scan();
    });

    scan();
  })();

  /* ---------- Sekcja wideo ---------- */
  // Modul rusza dopiero po `load` i pierwszej bezczynnosci. Karta produktu ma
  // najpierw pokazac zdjecie, cene i przycisk zakupu — obserwator, ktory
  // wystartowalby w trakcie parsowania, konkurowalby z nimi o watek glowny.
  const vkWhenIdle = (fn) => {
    const go = () => (window.requestIdleCallback
      ? window.requestIdleCallback(fn, { timeout: 2000 })
      : window.setTimeout(fn, 200));
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  };

  // Jedyne miejsce, gdzie motyw pyta o warunki sieci. saveData i effectiveType
  // sa tylko w Chromium — w Safari obu nie ma i wracamy do `true`, bo brak
  // odpowiedzi nie jest odpowiedzia „oszczedzaj".
  const vkDataOk = () => {
    const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;
    if (c.saveData) return false;
    return !c.effectiveType || c.effectiveType === '4g';
  };

  class VkVideo extends HTMLElement {
    connectedCallback() {
      this.stage = $('[data-vk-video-stage]', this);
      this.tpl = $('[data-vk-video-tpl]', this);
      this.ctl = $('[data-vk-video-ctl]', this);
      // Stan pusty (sprzedawca nie wskazal filmu): jest sama klatka zastepcza
      // albo szrafura .vk-placeholder i nie ma czym sterowac.
      if (!this.stage || !this.tpl || !this.ctl) return;

      this.ctlText = $('[data-vk-video-ctl-text]', this.ctl);
      this.ambient = this.dataset.vkMode !== 'film';
      this.video = null;
      this.stopped = false;   // uzytkownik nacisnal pauze — kadr go nie wznawia
      this.dead = false;      // plik nie dziala; nie probujemy w kolko
      this.io = null;

      this.rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      // Preferencja czytana na zywo (kontrakt utrzymania, punkt 3): wlaczenie
      // redukcji ruchu w trakcie sesji ma zatrzymac petle natychmiast.
      this.onRm = () => { if (this.rm.matches) this.pause(); this.arm(); };
      if (this.rm && this.rm.addEventListener) this.rm.addEventListener('change', this.onRm);

      this.onCtl = () => this.toggle();
      this.ctl.addEventListener('click', this.onCtl);

      this.onVis = () => {
        if (document.hidden) { if (this.video) this.video.pause(); }
        else if (this.ambient && !this.stopped && this.video) this.play();
      };
      document.addEventListener('visibilitychange', this.onVis);

      this.setState('idle');
      vkWhenIdle(() => this.arm());
    }

    disconnectedCallback() {
      // Edytor motywu podmienia sekcje w locie. Bez tego kazda edycja
      // zostawialaby zywy IntersectionObserver i nasluch na dokumencie.
      if (this.io) { this.io.disconnect(); this.io = null; }
      if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
      if (this.rm && this.rm.removeEventListener && this.onRm) this.rm.removeEventListener('change', this.onRm);
      if (this.ctl && this.onCtl) this.ctl.removeEventListener('click', this.onCtl);
      if (this.video) { this.video.pause(); this.video.removeAttribute('src'); this.video.load(); }
    }

    autoOk() {
      if (this.dead) return false;
      if (this.rm && this.rm.matches) return false;
      return vkDataOk();
    }

    arm() {
      if (this.io) { this.io.disconnect(); this.io = null; }
      // Film z dzwiekiem NIGDY nie startuje sam (WCAG 1.4.2). Petla startuje
      // tylko wtedy, gdy wolno: brak redukcji ruchu, brak trybu oszczedzania
      // danych, sensowna siec. W kazdym innym wypadku zostaje klatka zastepcza
      // z przyciskiem — czyli to samo, co widzi uzytkownik bez IntersectionObserver.
      if (!this.ambient || !this.autoOk() || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => {
        const en = entries[entries.length - 1];
        if (en.intersectionRatio >= 0.35) {
          if (!this.stopped) this.play();
        } else if (!en.isIntersecting && this.video) {
          this.video.pause();
        }
      }, { threshold: [0, 0.35] });
      this.io.observe(this.stage);
    }

    mount() {
      if (this.video) return this.video;
      if (this.dead) return null;
      // Klon z <template> — dopiero TERAZ przegladarka dostaje adres pliku.
      const v = this.tpl.content.cloneNode(true).querySelector('video');
      if (!v) { this.dead = true; return null; }

      // video_tag dokleja wlasny poster i zapasowy <img>. Oba pobralyby DRUGI
      // kadr tego samego ujecia — pierwszy lezy juz pod spodem jako
      // .vk-video__still i jest jedyna klatka zastepcza tej sekcji.
      v.removeAttribute('poster');
      const fb = v.querySelector('img');
      if (fb) fb.remove();
      // Autoodtwarzaniem steruje ten skrypt, nie atrybut: tylko wtedy da sie
      // przechwycic odmowe (iOS w trybie oszczedzania energii odrzuca play()).
      v.removeAttribute('autoplay');

      v.classList.add('vk-video__el');
      v.playsInline = true;             // bez tego iOS wchodzi w pelny ekran
      v.preload = 'auto';
      v.setAttribute('preload', 'auto');
      v.loop = this.ambient;
      v.controls = !this.ambient;
      v.muted = this.ambient;
      if (this.ambient) v.setAttribute('aria-hidden', 'true');

      const cc = this.dataset.vkCaptions;
      if (cc && !this.ambient) {
        // crossOrigin MUSI byc ustawione przed pierwszym pobraniem — element
        // jeszcze nie jest w dokumencie, wiec jestesmy na czas.
        v.crossOrigin = 'anonymous';
        const t = document.createElement('track');
        t.kind = 'captions';
        t.src = cc;
        t.srclang = (document.documentElement.lang || 'pl').slice(0, 2);
        t.label = this.dataset.vkCaptionsLabel || 'CC';
        t.default = true;
        v.appendChild(t);
      }

      v.addEventListener('playing', () => this.setState('playing'));
      v.addEventListener('pause', () => { if (!v.ended) this.setState('paused'); });
      v.addEventListener('ended', () => this.setState('idle'));
      v.addEventListener('error', () => this.fail());

      this.stage.insertBefore(v, this.ctl);
      this.video = v;
      return v;
    }

    play() {
      const v = this.mount();
      if (!v) return;
      this.setState('loading');
      const p = v.play();
      if (p && p.catch) {
        p.catch(() => {
          // Odmowa autoodtwarzania (iOS, tryb niskiego zuzycia energii, polityka
          // przegladarki). Wracamy do klatki zastepczej z widocznym przyciskiem
          // i WYLACZAMY obserwatora: druga proba bez gestu uzytkownika zostanie
          // odrzucona tak samo, a kazde przewiniecie probowaloby na nowo.
          if (this.io) { this.io.disconnect(); this.io = null; }
          this.setState('idle');
        });
      }
    }

    pause() {
      if (this.video) this.video.pause();
      this.setState('paused');
    }

    toggle() {
      const live = this.dataset.state === 'playing' || this.dataset.state === 'loading';
      if (live) { this.stopped = true; this.pause(); return; }
      this.stopped = false;
      this.play();
    }

    fail() {
      this.dead = true;
      if (this.io) { this.io.disconnect(); this.io = null; }
      if (this.video) { this.video.remove(); this.video = null; }
      // Zostaje sama klatka zastepcza — przycisk, ktory i tak nic nie zrobi,
      // bylby pulapka dla klawiatury i czytnika ekranu.
      this.ctl.hidden = true;
      this.setState('idle');
    }

    setState(s) {
      this.dataset.state = s;
      const live = s === 'playing' || s === 'loading';
      // Nazwa dostepna przycisku zmienia sie razem z ikona — sama zamiana
      // ikony nie zmienia niczego dla czytnika ekranu.
      const label = live ? this.dataset.vkPause : this.dataset.vkPlay;
      if (this.ctlText && label) this.ctlText.textContent = label;
      if (this.dead) return;
      // Film z dzwiekiem oddaje sterowanie natywnym kontrolkom <video>: pauza,
      // glosnosc, przewijanie i pelny ekran sa tam kompletne i znane z systemu.
      // Wlasny przycisk znika, ale fokus musi przejsc na film, a nie spasc na <body>.
      if (!this.ambient && live) {
        const hadFocus = document.activeElement === this.ctl;
        this.ctl.hidden = true;
        if (hadFocus && this.video) this.video.focus();
      }
    }
  }
  if (!window.customElements.get('vk-video')) window.customElements.define('vk-video', VkVideo);

  /*---------------------------------------------------------------------------
    VkIntro — zwijany opis kolekcji.

    Samo obciecie robi CSS pod `.js`, wiec ten komponent odpowiada wylacznie za
    stan: aria-expanded, etykiete i za rozbrojenie merchantowego <details>.

    Sprzedawca wkleja w opis wlasne <details><summary>Czytaj wiecej</summary>.
    Przy zamknietym obcieciu jego klikniecie nie zmienia NIC — zmierzone:
    scrollHeight rosnie z 321 do 2253 px, a wysokosc pudelka stoi na 62 px.
    Do tego ten summary ma 18 px wysokosci, czyli mniej niz polowe minimalnego
    celu dotykowego. Otwieramy go raz, przy starcie, a CSS chowa sam przelacznik:
    na stronie zostaje jeden przycisk 44 px, ktory naprawde steruje tekstem.
  ---------------------------------------------------------------------------*/
  class VkIntro extends HTMLElement {
    connectedCallback() {
      // Edytor motywu przenosi wezly, a connectedCallback odpala sie ponownie.
      if (this.vkReady) return;
      this.body = $('.vk-intro__body', this);
      this.btn = $('.vk-intro__toggle', this);
      if (!this.body || !this.btn) return;
      this.vkReady = true;
      this.label = $('.vk-intro__toggle-text', this.btn);
      $$('details', this.body).forEach((d) => { d.open = true; });
      this.btn.addEventListener('click', () => this.toggle());
      // Odnosnik w obcietej czesci nadal lapie Tab. Bez tego fokus wjezdza
      // w obszar przyciety przez overflow: hidden i wypycha go poza widok.
      this.addEventListener('focusin', (e) => {
        if (!this.hasAttribute('open') && this.body.contains(e.target)) this.setOpen(true);
      });
    }

    toggle() {
      const next = !this.hasAttribute('open');
      // Zwijanie od dolu dlugiego tekstu wyrzucaloby klienta w srodek siatki.
      if (!next && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' });
      this.setOpen(next);
    }

    setOpen(open) {
      this.toggleAttribute('open', open);
      this.btn.setAttribute('aria-expanded', String(open));
      if (!this.label) return;
      // Etykieta idzie z locales przez data-*, tak samo jak play/pause w VkVideo.
      const txt = open ? this.label.dataset.vkLess : this.label.dataset.vkMore;
      if (txt) this.label.textContent = txt;
    }
  }
  if (!window.customElements.get('vk-intro')) window.customElements.define('vk-intro', VkIntro);

  /* ---------- Hero: film w tle ---------- */
  // Atrybut `autoplay` NIE MOWI, czy film ruszyl. iOS w trybie niskiego zuzycia
  // energii i Chrome przy karcie otwartej w tle odrzucaja autoodtwarzanie takze
  // wyciszone, a bez obietnicy z play() nie ma czego przechwycic. Dotad
  // zostawal wtedy poster doklejony przez video_tag — miniatura 100 x 56 px
  // rozciagana na caly kadr. Teraz odtwarzaniem steruje ten skrypt, a kadr
  // trzyma ostra .vk-hero__still. Ten sam wzorzec ma juz sekcja wideo (VkVideo).
  const vkHeroVideo = (media) => {
    const tpl = $('[data-vk-hero-tpl]', media);
    if (!tpl || media.dataset.vkHeroReady === '1') return;
    media.dataset.vkHeroReady = '1';

    const rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    let v = null;
    let retried = false;

    const drop = () => {
      if (!v) return;
      const el = v;
      v = null;
      el.pause();
      // Zerowanie zrodla PRZED load() przerywa pobieranie w toku; samo remove()
      // zostawiloby transfer 10 MB w tle.
      el.removeAttribute('src');
      const src = el.querySelector('source');
      if (src) src.removeAttribute('src');
      el.load();
      el.remove();
    };

    const mount = () => {
      if (v) return v;
      const node = tpl.content.cloneNode(true).querySelector('video');
      if (!node) return null;
      // video_tag dokleja wlasny poster i zapasowy <img>. Oba pokazuja te sama
      // miniature _small; klatka zastepcza tej sekcji jest jedna i lezy nizej.
      node.removeAttribute('poster');
      const fb = node.querySelector('img');
      if (fb) fb.remove();
      // muted musi byc WLASNOSCIA (defaultMuted) przed pierwszym play(): dla
      // wezla sklonowanego z <template> Safari czyta sam atrybut za pozno i
      // odrzuca odtwarzanie jako „z dzwiekiem".
      node.defaultMuted = true;
      node.muted = true;
      node.setAttribute('muted', '');
      node.playsInline = true;
      node.setAttribute('playsinline', '');
      node.setAttribute('webkit-playsinline', '');
      node.preload = 'auto';
      node.setAttribute('preload', 'auto');
      node.setAttribute('aria-hidden', 'true');
      node.tabIndex = -1;
      // Widoczny dopiero na 'playing', czyli po pierwszej ZDEKODOWANEJ klatce.
      // 'canplay' i 'loadeddata' potrafia padac, zanim jest co pokazac.
      node.addEventListener('playing', () => node.classList.add('is-live'));
      node.addEventListener('error', drop, { once: true });
      media.appendChild(node);
      v = node;
      return v;
    };

    const start = () => {
      if (!media.isConnected) return;
      if (rm && rm.matches) return;
      const node = mount();
      if (!node) return;
      const p = node.play();
      if (p && p.catch) {
        p.catch(() => {
          // Odmowa. Film zostaje w DOM, ale bez klasy is-live jest przezroczysty
          // — na ekranie stoi ostra klatka zastepcza, nie czarny prostokat.
          // Jedna ponowna proba przy pierwszym gescie: gest zdejmuje blokade.
          node.classList.remove('is-live');
          if (retried) return;
          retried = true;
          const again = () => start();
          document.addEventListener('pointerdown', again, { once: true, passive: true });
          document.addEventListener('touchend', again, { once: true, passive: true });
        });
      }
    };

    // Karta otwarta w tle albo przelaczona aplikacja: Chrome odrzuca kazde
    // play(), a 'playing' nigdy nie pada. Pierwsze wyjscie na wierzch jest
    // naturalna druga proba — i przy okazji nie mielimy filmu poza ekranem.
    document.addEventListener('visibilitychange', () => {
      if (!media.isConnected) return;
      if (document.hidden) { if (v) v.pause(); return; }
      start();
    });

    // Preferencja czytana na zywo, jak w VkVideo i w pasku informacyjnym.
    if (rm && rm.addEventListener) {
      rm.addEventListener('change', () => {
        if (!media.isConnected) return;
        if (rm.matches) drop(); else start();
      });
    }

    start();
  };

  $$('[data-vk-hero-video]').forEach(vkHeroVideo);
  // Edytor motywu podmienia sekcje w locie — nowy DOM nie ma jeszcze filmu.
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-vk-hero-video]', e.target).forEach(vkHeroVideo);
  });

  $$('[data-vk-shipbar]').forEach((el) => {
    const total = parseInt(el.dataset.vkShipbar, 10);
    if (!isNaN(total)) paintShipBar(el, total);
  });
})();

/*=============================================================================
  VANKEL Heritage — pasek zgody na pliki cookie (VkCookies).

  Osobny blok IIFE na koncu pliku: komponent nie potrzebuje zadnego pomocnika
  z bloku glownego, wiec dopisanie tutaj nie wchodzi w droge zmianom w tamtym.

  Zgoda idzie przez Shopify Customer Privacy API. Pasek NIE trzyma wyboru
  u siebie — pamiecia jest cookie _tracking_consent po stronie Shopify, ta sama,
  ktora czyta Checkout i analityka sklepu. Samo schowanie paska bez wywolania
  setTrackingConsent nie byloby zgoda w rozumieniu RODO.
=============================================================================*/
(function () {
  'use strict';

  // Cztery klucze przyjmowane przez setTrackingConsent. marketing/analytics/
  // preferences to kategorie RODO; sale_of_data dotyczy stanow USA.
  var VK_CONSENT_KEYS = ['analytics', 'marketing', 'preferences', 'sale_of_data'];

  // Pamiec wyboru po stronie motywu.
  //
  // POWOD: na tym sklepie Shopify nie zapisuje ciasteczka _tracking_consent.
  // Zmierzone na zywo (podsluch settera document.cookie): po zgodzie leca
  // zapisy _ga i _ga_*, ale _tracking_consent nie pojawia sie ani razu,
  // a shouldShowBanner() dalej zwraca true — wiec pasek wracal przy kazdej
  // zmianie podstrony. Proba kontrolna z WLASNYM banerem Shopify dala
  // dokladnie ten sam wynik, czyli nie jest to blad tego komponentu.
  //
  // Dlatego wybor zapamietujemy sami i przy kazdym wejsciu nakladamy go
  // ponownie przez setTrackingConsent — API pozostaje jedynym zrodlem prawdy
  // dla samego sledzenia, a nasz zapis odpowiada wylacznie za to, czy pasek
  // ma sie jeszcze pokazac.
  var VK_CONSENT_STORE = 'vk:consent';

  function vkReadConsent(maxDni) {
    try {
      var raw = window.localStorage.getItem(VK_CONSENT_STORE);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.c !== 'object' || typeof data.t !== 'number') return null;
      // Zgoda nie jest wieczna: po uplywie waznosci pytamy jeszcze raz.
      if (maxDni > 0 && (Date.now() - data.t) > maxDni * 86400000) return null;
      return data.c;
    } catch (e) { return null; }
  }

  function vkWriteConsent(consent) {
    try {
      window.localStorage.setItem(VK_CONSENT_STORE, JSON.stringify({ c: consent, t: Date.now() }));
    } catch (e) { /* tryb prywatny albo brak miejsca — pasek po prostu zapyta znowu */ }
  }

  class VkCookies extends HTMLElement {
    connectedCallback() {
      this.prefs = this.querySelector('[data-vk-cookies-prefs]');
      this.toggleBtn = this.querySelector('[data-vk-cookies-toggle]');
      this.status = this.querySelector('[data-vk-cookies-status]');
      this.sodRow = this.querySelector('[data-vk-cookies-row-sod]');
      this.delay = parseInt(this.dataset.vkDelay, 10) || 0;
      // 0 = bez terminu waznosci; wartosc pochodzi z pola w Edytorze motywu.
      this.maxDni = parseInt(this.dataset.vkDays, 10) || 0;
      this.tries = 0;

      this.addEventListener('click', this.onClick.bind(this));

      // Wycofanie zgody musi byc tak samo latwe jak jej udzielenie, wiec
      // dowolny element z [data-vk-cookies-open] (np. link w stopce) otwiera
      // pasek z rozwinietymi ustawieniami.
      this.onDocClick = function (e) {
        if (!e.target || !e.target.closest) return;
        var trigger = e.target.closest('[data-vk-cookies-open]');
        if (!trigger) return;
        e.preventDefault();
        this.reveal(true);
      }.bind(this);
      document.addEventListener('click', this.onDocClick);

      this.loadApi();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }

    loadApi() {
      var S = window.Shopify;
      // Bez API nie ma czym sterowac zgoda — pasek zostaje ukryty, zamiast
      // udawac, ze cokolwiek zapisuje.
      if (!S || typeof S.loadFeatures !== 'function') return;
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return;
        this.api = S.customerPrivacy;
        if (!this.api || typeof this.api.shouldShowBanner !== 'function') return;
        // Dopoki wlasciciel nie usunie wbudowanego banera w panelu Shopify,
        // pokazalyby sie dwa paski naraz. Chowamy tamten DOPIERO tutaj, czyli
        // w chwili, gdy nasz ma juz czym sterowac zgoda. Gdy vk-theme.js nie
        // wstanie albo API nie odpowie, klasa nie zostaje nadana i baner
        // Shopify dziala jak dotad — sklep nigdy nie zostaje bez mechanizmu
        // zgody. Docelowo baner Shopify nalezy usunac w panelu; to jest most
        // na czas przelaczenia.
        document.documentElement.classList.add('vk-cookies-live');
        this.paintRegion();
        this.decide();
      }.bind(this));
    }

    // Przelacznik sprzedazy danych ma sens tylko w regionie, ktory tego wymaga.
    paintRegion() {
      if (!this.sodRow) return;
      var need = typeof this.api.saleOfDataRegion === 'function' && this.api.saleOfDataRegion();
      this.sodRow.hidden = !need;
    }

    decide() {
      // Wybor zapamietany u nas: nakladamy go po cichu i nie pokazujemy paska.
      // Bez tego pasek wracal na kazdej podstronie, bo shouldShowBanner()
      // opiera sie na ciasteczku, ktorego ten sklep nie dostaje.
      var zapisany = vkReadConsent(this.maxDni);
      if (zapisany) {
        this.api.setTrackingConsent(zapisany, function () {});
        return;
      }
      if (this.api.shouldShowBanner()) {
        window.setTimeout(this.reveal.bind(this, false), this.delay);
        return;
      }
      // shouldShowBanner() czyta cookie _tracking_consent, ktore przy pierwszej
      // wizycie bywa zapisane dopiero po odpowiedzi serwera. Kilka podejsc
      // i koniec — poza regionem zgody odpowiedz i tak zostanie na false.
      if (this.tries < 8) {
        this.tries += 1;
        window.setTimeout(this.decide.bind(this), 250);
      }
    }

    reveal(fromTrigger) {
      // Ponowne otwarcie moze trafic w trwajace domykanie: kasujemy zaplanowane
      // ukrycie i sluchacza konca przejscia, inaczej wjezdzajacy pasek zostalby
      // schowany wlasnym transitionend z poprzedniego cyklu.
      window.clearTimeout(this.hideTimer);
      window.clearTimeout(this.failSafe);
      if (this.finishHandler) {
        this.removeEventListener('transitionend', this.finishHandler);
        this.finishHandler = null;
      }
      this.closing = false;
      var wasHidden = this.hidden;
      this.hidden = false;
      if (wasHidden) {
        // Klasa w nastepnej klatce, zeby przejscie mialo od czego wystartowac.
        // Przy prefers-reduced-motion tokeny ruchu sa zbite do 1ms w arkuszu.
        window.requestAnimationFrame(function () { this.classList.add('is-open'); }.bind(this));
      }
      if (!fromTrigger) return;
      // Otwarcie z wlasnej woli uzytkownika: rozwijamy ustawienia i przenosimy
      // fokus. Przy pokazaniu automatycznym fokusu NIE zabieramy — pasek nie
      // jest oknem modalnym i nie ma prawa przerywac czytania strony.
      this.setPrefs(true);
      this.syncInputs();
      var first = this.querySelector('.vk-cookies__input') || this.querySelector('button');
      if (first) first.focus();
    }

    // Przelaczniki startuja od stanu faktycznie zapisanego, a nie od zera.
    syncInputs() {
      if (!this.api || typeof this.api.currentVisitorConsent !== 'function') return;
      var now = this.api.currentVisitorConsent() || {};
      VK_CONSENT_KEYS.forEach(function (key) {
        var input = this.querySelector('[data-vk-consent="' + key + '"]');
        if (input) input.checked = now[key] === true || now[key] === 'yes';
      }.bind(this));
    }

    setPrefs(open) {
      if (!this.prefs || !this.toggleBtn) return;
      this.prefs.hidden = !open;
      this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    onClick(e) {
      var btn = e.target.closest ? e.target.closest('[data-vk-cookies-action]') : null;
      if (!btn || !this.contains(btn)) return;
      var action = btn.dataset.vkCookiesAction;

      if (action === 'prefs') {
        var willOpen = this.prefs ? this.prefs.hidden : false;
        if (willOpen) this.syncInputs();
        this.setPrefs(willOpen);
        return;
      }
      if (action === 'accept') { this.save(true); return; }
      if (action === 'decline') { this.save(false); return; }
      if (action === 'save') { this.save(null); return; }
    }

    // all === true / false -> wszystko wlaczone albo wszystko wylaczone.
    // all === null -> stan przelacznikow.
    save(all) {
      if (!this.api || typeof this.api.setTrackingConsent !== 'function') return;
      var consent = {};
      VK_CONSENT_KEYS.forEach(function (key) {
        if (all !== null) { consent[key] = all; return; }
        var input = this.querySelector('[data-vk-consent="' + key + '"]');
        consent[key] = input ? input.checked : false;
      }.bind(this));
      // Gdy wiersz sprzedazy danych jest schowany (region poza USA), nie ma
      // wlasnego przelacznika — idzie razem z marketingiem, zeby jeden pasek
      // obsluzyl oba porzadki prawne.
      if (all === null && this.sodRow && this.sodRow.hidden) {
        consent.sale_of_data = consent.marketing;
      }
      vkWriteConsent(consent);
      this.api.setTrackingConsent(consent, this.done.bind(this));
      // Wywolanie zwrotne potrafi nie przyjsc (blad sieci). Pasek nie moze
      // przez to zostac na ekranie na zawsze.
      this.failSafe = window.setTimeout(this.done.bind(this), 1200);
    }

    done() {
      if (this.closing) return;
      this.closing = true;
      window.clearTimeout(this.failSafe);
      if (this.status) this.status.textContent = this.dataset.vkSaved || '';
      this.classList.remove('is-open');

      var finish = function (ev) {
        if (ev && ev.target !== this) return;
        this.removeEventListener('transitionend', finish);
        this.finishHandler = null;
        window.clearTimeout(this.hideTimer);
        this.hidden = true;
        this.setPrefs(false);
        this.closing = false;
      }.bind(this);
      this.finishHandler = finish;
      this.addEventListener('transitionend', finish);
      // Bezpiecznik, nie wartosc projektowa: przy prefers-reduced-motion
      // przejscie trwa 1ms i transitionend moze nie dojsc.
      this.hideTimer = window.setTimeout(finish, 1000);
    }
  }

  if (!window.customElements.get('vk-cookies')) window.customElements.define('vk-cookies', VkCookies);
})();

/*=============================================================================
  VANKEL Heritage — kalkulator rozmiaru (VkSizeCalc).

  Osobny blok IIFE na koncu pliku, tak samo jak pasek zgody: komponent nie
  potrzebuje zadnego pomocnika z bloku glownego, wiec dopisanie tutaj nie
  wchodzi w droge zmianom w tamtym.

  Dwa niezalezne przeliczniki w jednym elemencie:
    A. szerokosc spodni zmierzonych na plasko (cm) -> obwod w pasie (razy 2)
       -> rozmiar na siatce co N cm (N z Ustawien motywu).
    B. dlugosc od kroku w dol (cm) -> cale (przez 2,54) -> rozmiar calowy.

  ZERO tekstu w tym pliku. Kazdy napis przychodzi z data-atrybutow, ktore
  snippets/vk-size-calc.liquid wypelnia z locales — ten sam uklad, co
  data-vk-saved w VkCookies. Miejsca na liczby zapisane sa jako [nazwa],
  tak jak [percent] w products.product.save_percent.
=============================================================================*/
(function () {
  'use strict';

  // Centymetry w calu. Stala fizyczna, a nie decyzja sprzedawcy — jako jedyna
  // liczba w tym pliku nie ma pola w Edytorze motywu.
  var VK_INCH = 2.54;

  /* ---------- Wpis od czlowieka ---------- */
  // Klawiatura telefonu daje przecinek albo kropke zaleznie od ustawien
  // jezyka, a ludzie dopisuja jednostke („82 cm") i spacje. Kolejnosc krokow
  // jest istotna: przecinek na kropke IDZIE PRZED usunieciem reszty znakow,
  // bo odwrotnie „82,5" zostaloby sklejone w „825".
  // Dwa separatory, dwa minusy albo minus w srodku („42-44") to wpis
  // niejednoznaczny — zwracamy NaN i mowimy o tym, zamiast zgadywac.
  function vkNum(raw) {
    if (typeof raw !== 'string') return NaN;
    var s = raw
      .replace(/[   ]/g, ' ')
      .replace(/[‐-―−]/g, '-')
      .replace(/,/g, '.')
      .trim();
    if (!s) return NaN;
    s = s.replace(/[^0-9.\-]/g, '');
    if (!s) return NaN;
    if ((s.match(/\./g) || []).length > 1) return NaN;
    if ((s.match(/-/g) || []).length > 1) return NaN;
    if (s.indexOf('-') > 0) return NaN;
    var n = parseFloat(s);
    return isFinite(n) ? n : NaN;
  }

  // Liczba dla oka. Separator dziesietny bierzemy z jezyka dokumentu, dokladnie
  // tak jak formatMoney w bloku glownym — po polsku wychodzi „29,9", a nie
  // „29.92834645669291". Dwa zapasy pod Intl niedostepny w starej przegladarce.
  function vkFmt(n, dec) {
    var loc = document.documentElement.lang || undefined;
    var opts = { minimumFractionDigits: 0, maximumFractionDigits: dec };
    try { return new Intl.NumberFormat(loc, opts).format(n); } catch (e) { /* nastepny zapas */ }
    try { return n.toLocaleString(loc, opts); } catch (e) { /* nastepny zapas */ }
    return String(Math.round(n * 100) / 100);
  }

  // Przyciagniecie do siatki rozmiarow. EPS zdejmuje smiec zmiennoprzecinkowy:
  // bez niego wartosc lezaca DOKLADNIE na siatce, ale zapisana jako
  // 30.000000000000004, skakala w trybie „w gore" o caly rozmiar wyzej.
  function vkSnap(value, step, mode) {
    if (!(step > 0)) return value;
    var EPS = 1e-9;
    var q = value / step;
    if (mode === 'down') return Math.floor(q + EPS) * step;
    if (mode === 'nearest') return Math.round(q) * step;
    return Math.ceil(q - EPS) * step;
  }

  // Podstawienie liczb w szablon z locales. split/join, a nie replace:
  // replace bez flagi g podmienia tylko pierwsze wystapienie, a [size] potrafi
  // wystapic w zdaniu dwa razy.
  function vkFill(tpl, map) {
    if (!tpl) return '';
    var out = String(tpl);
    for (var key in map) {
      if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
      out = out.split('[' + key + ']').join(map[key]);
    }
    return out;
  }

  // Liczba z data-atrybutu. NIE `parseFloat(x) || zapas`: zero jest w JS falszywe,
  // wiec sprzedawca, ktory wpisze 0 w polu granicy, dostalby po cichu wartosc
  // domyslna zamiast swojej.
  function vkCfgNum(raw, fallback) {
    var n = parseFloat(raw);
    return isFinite(n) ? n : fallback;
  }

  // Granice odwrocone w Edytorze (minimum wieksze od maksimum) zabilyby
  // kalkulator na gluche „poza zakresem" przy kazdym wpisie. Czytamy je
  // zyczliwie, jako przedzial, a nie jako kolejnosc.
  function vkRange(a, b) {
    return a <= b ? { min: a, max: b } : { min: b, max: a };
  }

  class VkSizeCalc extends HTMLElement {
    connectedCallback() {
      var d = this.dataset;
      // Drugi argument vkCfgNum to zapas na wypadek motywu wgranego, zanim pola
      // trafily do Ustawien — nie jest druga definicja wartosci domyslnej.
      this.cfg = {
        step: vkCfgNum(d.vkStep, 2),
        inchStep: vkCfgNum(d.vkInchStep, 1),
        mode: d.vkRound || 'up',
        delay: vkCfgNum(d.vkDelay, 400),
        waist: vkRange(vkCfgNum(d.vkFlatMin, 25), vkCfgNum(d.vkFlatMax, 75)),
        len: vkRange(vkCfgNum(d.vkLenMin, 50), vkCfgNum(d.vkLenMax, 100))
      };
      this.live = this.querySelector('[data-vk-calc-live]');
      this.liveValue = this.querySelector('[data-vk-calc-live-value]');
      this.liveNote = this.querySelector('[data-vk-calc-live-note]');
      // Pole „dotkniete" = klient je juz opuscil. Do tego czasu wpis za krotki
      // („4" w drodze do „41") NIE jest bledem, tylko stanem w toku.
      this.touched = {};

      this.addEventListener('input', this.onInput.bind(this));
      // focusout, a nie blur: blur nie propaguje w gore, wiec nasluch zawieszony
      // na kontenerze nigdy by go nie zobaczyl.
      this.addEventListener('focusout', this.onLeave.bind(this));

      // Powrot przyciskiem „wstecz" i autouzupelnianie przegladarki oddaja pola
      // juz wypelnione — liczymy od razu, nie czekajac na pierwszy klawisz.
      this.paint('waist', false);
      this.paint('len', false);
    }

    disconnectedCallback() {
      window.clearTimeout(this.sayTimer);
    }

    onInput(e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-vk-calc-input]') : null;
      if (!input || !this.contains(input)) return;
      this.paint(input.dataset.vkCalcInput, true);
    }

    onLeave(e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-vk-calc-input]') : null;
      if (!input || !this.contains(input)) return;
      this.touched[input.dataset.vkCalcInput] = true;
      this.paint(input.dataset.vkCalcInput, false);
    }

    // Jedno przejscie: wpis -> stan -> dwa napisy (glowny i objasnienie).
    paint(name, fromTyping) {
      var input = this.querySelector('[data-vk-calc-input="' + name + '"]');
      if (!input) return;
      var box = this.querySelector('[data-vk-calc-out="' + name + '"]');
      var valueEl = box ? box.querySelector('[data-vk-calc-value]') : null;
      var noteEl = box ? box.querySelector('[data-vk-calc-note]') : null;
      var d = this.dataset;
      var lim = name === 'len' ? this.cfg.len : this.cfg.waist;
      var rangeTpl = name === 'len' ? d.vkErrLenRange : d.vkErrWaistRange;
      var value = '';
      var note = '';
      var bad = false;
      var raw = input.value;

      if (typeof raw !== 'string' || raw.trim() === '') {
        // Puste pole: ani wyniku, ani bledu. Nie karzemy za nierozpoczete zadanie.
      } else {
        var n = vkNum(raw);
        if (isNaN(n)) {
          bad = true;
          note = d.vkErrNumber || '';
        } else if (n > lim.max) {
          // Najczestsza pomylka w polu obwodu: klient wpisuje SWOJ obwod w pasie
          // zamiast szerokosci spodni na plasko. Polowa takiego wpisu miesci sie
          // w zakresie — mowimy wtedy wprost, co poszlo nie tak, zamiast
          // odbijac go suchym komunikatem o zakresie.
          if (name === 'waist' && n / 2 >= lim.min && n / 2 <= lim.max) {
            bad = true;
            note = d.vkErrCirc || '';
          } else {
            bad = true;
            note = vkFill(rangeTpl, { min: vkFmt(lim.min, 1), max: vkFmt(lim.max, 1) });
          }
        } else if (n < lim.min) {
          // Za malo. Przy pierwszym wejsciu w pole to zwykle wpis w toku,
          // wiec milczymy; po opuszczeniu pola mowimy, jaki jest zakres.
          if (n > 0 && !this.touched[name]) {
            // wpis w toku — bez wyniku i bez bledu
          } else {
            bad = true;
            note = vkFill(rangeTpl, { min: vkFmt(lim.min, 1), max: vkFmt(lim.max, 1) });
          }
        } else if (name === 'waist') {
          // Wpis kwantowany do 0,1 cm ZANIM cokolwiek policzymy. Dwa powody:
          // 1. Objasnienie pokazuje klientowi rachunek: „41,3 cm x 2 = 82,6 cm".
          //    Gdyby liczba w rachunku byla zaokraglana dopiero do pokazania,
          //    a mnozenie szlo z pelnego wpisu, klient czytalby dzialanie, ktore
          //    sie NIE zgadza: 41,25 pokazane jako 41,3 razy 2 dawalo 82,5.
          // 2. Miarka krawiecka i tak nie czyta ponizej milimetra, wiec 0,1 cm
          //    to granica sensu, a nie utrata dokladnosci.
          n = Math.round(n * 10) / 10;
          // Obwod zaokraglony ponownie: mnozenie zostawia ogon typu
          // 82.19999999999999, ktory przy trybie „w dol" zbija wynik o rozmiar.
          var obw = Math.round(n * 2 * 10) / 10;
          var size = vkSnap(obw, this.cfg.step, this.cfg.mode);
          var lower = vkSnap(obw, this.cfg.step, 'down');
          var upper = vkSnap(obw, this.cfg.step, 'up');
          value = vkFill(d.vkTplWaistSize, { size: vkFmt(size, 0) });
          note = vkFill(d.vkTplWaistCalc, { flat: vkFmt(n, 1), cm: vkFmt(obw, 1) });
          // Notka „miedzy rozmiarami" tylko wtedy, gdy naprawde zaokraglilismy.
          // [size] jest tu OBOWIAZKOWE obok [lower] i [upper]: tryb zaokraglania
          // jest polem w Edytorze, wiec zdanie „bierz wiekszy" wpisane na sztywno
          // w locales klamaloby po przestawieniu go na „w dol".
          if (lower !== upper) {
            note += ' ' + vkFill(d.vkTplWaistBetween, {
              lower: vkFmt(lower, 0), upper: vkFmt(upper, 0), size: vkFmt(size, 0)
            });
          }
        } else {
          // Ta sama kwantyzacja co przy obwodzie — objasnienie pokazuje
          // dzielenie i musi sie zgadzac z liczba, ktora widzi klient.
          n = Math.round(n * 10) / 10;
          var inch = n / VK_INCH;
          var isize = vkSnap(inch, this.cfg.inchStep, 'nearest');
          value = vkFill(d.vkTplLenSize, { size: vkFmt(isize, 0) });
          note = vkFill(d.vkTplLenCalc, { cm: vkFmt(n, 1), inch: vkFmt(inch, 1) });
        }
      }

      if (valueEl) valueEl.textContent = value;
      if (noteEl) noteEl.textContent = note;
      if (box) {
        box.classList.toggle('vk-size-calc__out--error', bad);
        box.hidden = !value && !note;
      }
      // aria-invalid tylko przy prawdziwym bledzie. Ustawiane po kazdej cyfrze
      // zamienialoby pole w migajaca czerwona lampke w drodze do poprawnej liczby.
      if (bad) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');

      this.say(value, note, fromTyping);
    }

    // Wynik ma sie POKAZAC natychmiast, ale ZABRZMIEC dopiero po chwili ciszy.
    //
    // Dlaczego nie aria-live na widocznym wyniku: region live odswiezany przy
    // kazdym wcisnieciu klawisza ustawia w kolejce ogloszenia „8", „82", „82 c",
    // ktore wpadaja na echo pisania. Polite tego nie ratuje — polite decyduje
    // tylko o tym, ze ogloszenie nie przerywa, a nie o tym, ze nie powstaje.
    //
    // Dlatego dwa kanaly: widoczny wynik nie ma zadnej semantyki live i zmienia
    // sie w tej samej klatce co pisanie, a osobne pudelko role="status"
    // aria-live="polite" (wizualnie ukryte) dostaje gotowe zdanie dopiero po
    // przerwie w pisaniu. role="status" ORAZ aria-live sa podane oba naraz,
    // bo mapowanie samej roli na region live bywalo w czytnikach nierowne.
    say(value, note, debounced) {
      if (!this.live) return;
      window.clearTimeout(this.sayTimer);
      var write = function () {
        if (this.liveValue) this.liveValue.textContent = value;
        if (this.liveNote) this.liveNote.textContent = note;
      }.bind(this);
      if (!debounced) { write(); return; }
      this.sayTimer = window.setTimeout(write, this.cfg.delay);
    }
  }

  if (!window.customElements.get('vk-size-calc')) window.customElements.define('vk-size-calc', VkSizeCalc);
})();

/*=============================================================================
  <vk-returns-form> — formularz zwrotow z aplikacji, osadzony w stronie motywu.

  Tresc formularza nalezy do aplikacji zwrotow, nie do motywu: to tam siedzi
  limit prob, wyszukanie zamowienia i wysylka potwierdzenia. Komponent pobiera
  gotowy fragment HTML spod <sciezka proxy>/embed i podmienia go przy kazdym
  kroku, wiec klient przechodzi caly proces bez opuszczania tej podstrony.

  Zadanie leci na domene sklepu — Shopify sam przekazuje je do aplikacji i
  podpisuje. Zadnego klucza ani CORS-a tu nie ma i byc nie moze.

  Gdy skrypt nie wstanie albo siec padnie, w srodku zostaje odnosnik do
  samodzielnej strony zwrotow. Sciezka zwrotu jest sciezka prawna i nie wolno
  jej uzaleznic od tego, czy JavaScript sie wykona.
=============================================================================*/
(function () {
  'use strict';

  class VkReturnsForm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.path = (this.getAttribute('data-path') || '').replace(/\/+$/, '');
      this.box = this.querySelector('[data-vk-returns-box]');
      if (!this.box || !this.path) return;

      // Delegacja na stalym pojemniku, a nie na formularzu: tresc jest
      // podmieniana przy kazdym kroku, wiec nasluch wpiety w sam formularz
      // znikalby razem z nim.
      this.box.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        e.preventDefault();
        this.send(form);
      });

      this.load();
    }

    get endpoint() {
      return this.path + '/embed';
    }

    text(name) {
      return this.getAttribute('data-' + name) || '';
    }

    /* Po podmianie tresci czytnik ekranu musi dowiedziec sie, ze cos sie
       zmienilo, a klawiatura nie moze wrocic na poczatek strony. */
    refocus() {
      const target =
        this.box.querySelector('[role=alert]') ||
        this.box.querySelector('[role=status]') ||
        this.box.querySelector('input, select, button');
      if (!target) return;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }

    swap(html) {
      this.box.innerHTML = html;
      this.refocus();
    }

    fallback(message) {
      const p = document.createElement('p');
      p.className = 'vk-returns-form__error';
      p.setAttribute('role', 'alert');
      p.textContent = message;
      const a = document.createElement('a');
      a.className = 'vk-btn vk-btn--primary';
      a.href = this.path;
      a.textContent = this.text('link');
      this.box.innerHTML = '';
      this.box.appendChild(p);
      this.box.appendChild(a);
    }

    load() {
      fetch(this.endpoint, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => this.swap(html))
        .catch(() => this.fallback(this.text('error')));
    }

    send(form) {
      const button = form.querySelector('button[type=submit], button:not([type])');
      if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

      fetch(this.endpoint, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => this.swap(html))
        .catch(() => {
          // Formularz zostaje na ekranie z odblokowanym przyciskiem — klient
          // moze sprobowac jeszcze raz zamiast tracic wpisane dane.
          if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
          let info = this.box.querySelector('[data-vk-returns-error]');
          if (!info) {
            info = document.createElement('p');
            info.setAttribute('data-vk-returns-error', '');
            info.setAttribute('role', 'alert');
            info.className = 'vk-returns-form__error';
            this.box.insertBefore(info, this.box.firstChild);
          }
          info.textContent = this.text('error');
        });
    }
  }

  if (!window.customElements.get('vk-returns-form')) {
    window.customElements.define('vk-returns-form', VkReturnsForm);
  }
})();

/*=============================================================================
  <vk-jump> — plynne przewiniecie do kotwicy wewnatrz strony.

  Motyw NIE ma globalnego scroll-behavior: smooth i celowo go nie dostaje.
  Wlaczenie go na <html> zmienia zachowanie kazdego skoku w calym sklepie —
  takze linku pomijajacego nawigacje i miniatur galerii. Tutaj przewijanie
  dotyczy tylko odnosnikow w srodku tego elementu.

  Bez skryptu odnosnik dziala jak zwykla kotwica: przeskok natychmiastowy,
  ale trafia tam, gdzie ma trafic.
=============================================================================*/
(function () {
  'use strict';

  class VkJump extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link || !this.contains(link)) return;

        const id = link.getAttribute('href').slice(1);
        if (!id) return;
        const target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();

        // Skala ruchu motywu jest zbijana do 1ms przy prefers-reduced-motion,
        // ale scrollIntoView nie czyta zmiennych CSS — pytamy wprost.
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });

        // Natywny skok przenosi tez ognisko klawiatury. scrollIntoView tego
        // nie robi, wiec czytnik ekranu i tabulator zostalyby przy kafelku.
        try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }

        // Adres w pasku zmienia sie bez kolejnego skoku, zeby dalo sie
        // podeslac link prosto do krokow.
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + id);
        }
      });
    }
  }

  if (!window.customElements.get('vk-jump')) {
    window.customElements.define('vk-jump', VkJump);
  }
})();

/*=============================================================================
  <vk-stores> — lista punktow sprzedazy z mapa obok.

  Klikniecie "Pokaz na mapie" podmienia adres ramki zamiast ladowac szesc map
  naraz. Przy szesciu osadzonych mapach strona ciagnelaby szesc niezaleznych
  aplikacji Google — tutaj jest jedna i tylko zmienia wspolrzedne.

  Przyciski przychodza z serwera ukryte (atrybut hidden) i odslania je dopiero
  ten komponent. Bez JavaScriptu przelaczanie nie dziala, a martwy przycisk
  jest gorszy od jego braku — link "Trasa" obok dziala zawsze.
=============================================================================*/
(function () {
  'use strict';

  class VkStores extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.frame = this.querySelector('[data-vk-map-frame]');
      this.mapBox = this.querySelector('[data-vk-map]');
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-map-src]'));
      if (!this.frame || !this.buttons.length) return;

      this.buttons.forEach((b) => b.removeAttribute('hidden'));

      // Pierwszy przycisk odpowiada mapie, ktora serwer juz wyrenderowal.
      this.mark(this.buttons[0]);

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-map-src]');
        if (!btn || !this.contains(btn)) return;
        this.show(btn);
      });
    }

    mark(active) {
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', b === active ? 'true' : 'false'));
    }

    show(btn) {
      const src = btn.getAttribute('data-map-src');
      if (!src || this.frame.getAttribute('src') === src) return;

      this.frame.setAttribute('src', src);
      const city = btn.getAttribute('data-map-city');
      if (city) this.frame.setAttribute('title', city);
      this.mark(btn);

      // Na waskim ekranie mapa lezy POD lista i podmiana byla niewidoczna —
      // klient klikal i nic sie dla niego nie dzialo. Lepka kolumna na szerokim
      // ekranie jest widoczna caly czas, wiec tam nie ruszamy przewijania.
      const lepka = window.getComputedStyle(this.mapBox).position === 'sticky';
      if (lepka || !this.mapBox) return;
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mapBox.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'nearest' });
    }
  }

  if (!window.customElements.get('vk-stores')) {
    window.customElements.define('vk-stores', VkStores);
  }
})();

/*=============================================================================
  Walidacja kafelków wyboru w formularzu B2B.

  Pola radio siedzą pod kafelkami z opacity: 0. Gdyby zostały oznaczone
  natywnym `required`, przeglądarka przy braku wyboru blokowałaby wysyłkę
  i próbowała pokazać komunikat przy elemencie, którego nie widać — z
  perspektywy klienta przycisk po prostu przestaje działać, bez żadnej
  informacji dlaczego. Dlatego sprawdzamy to sami i mówimy wprost, czego
  brakuje, przy widocznej grupie kafelków.
=============================================================================*/
(function () {
  'use strict';

  function komunikat(grupa, tekst) {
    var p = grupa.parentNode.querySelector('[data-vk-grupa-blad]');
    if (!p) {
      p = document.createElement('p');
      p.setAttribute('data-vk-grupa-blad', '');
      p.setAttribute('role', 'alert');
      p.className = 'vk-b2b-tiles__error';
      grupa.parentNode.insertBefore(p, grupa.nextSibling);
    }
    p.textContent = tekst;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var grupy = form.querySelectorAll('[data-vk-wymagane]');
    if (!grupy.length) return;

    var pierwszaPusta = null;
    Array.prototype.forEach.call(grupy, function (g) {
      var wybrany = g.querySelector('input[type=radio]:checked');
      var blad = g.parentNode.querySelector('[data-vk-grupa-blad]');
      if (wybrany) {
        g.removeAttribute('data-vk-blad');
        if (blad) blad.remove();
      } else {
        g.setAttribute('data-vk-blad', 'true');
        komunikat(g, g.getAttribute('data-vk-wymagane'));
        if (!pierwszaPusta) pierwszaPusta = g;
      }
    });

    if (!pierwszaPusta) return;
    e.preventDefault();
    var cel = pierwszaPusta.querySelector('input[type=radio]');
    if (cel) {
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pierwszaPusta.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      try { cel.focus({ preventScroll: true }); } catch (err) { /* pole jest przezroczyste */ }
    }
  });
})();

/*=============================================================================
  <vk-buybar> — przyklejony pasek zakupu na wąskim ekranie.

  Nie wysyła własnego żądania do koszyka. Jego przycisk klika prawdziwy
  przycisk w formularzu produktu, więc wybrany wariant, obsługa błędów
  i otwarcie szuflady koszyka działają dokładnie tak samo jak wyżej —
  bez drugiej kopii tej logiki, która musiałaby być utrzymywana równolegle.

  Cena i stan „wyprzedane” są przepisywane z sekcji produktu przez
  MutationObserver, więc pasek nadąża za zmianą wariantu, nie wiedząc nic
  o wnętrzu selektora wariantów.
=============================================================================*/
(function () {
  'use strict';

  class VkBuybar extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.cta = document.querySelector('.vk-product__cta');
      this.realny = document.querySelector('[data-vk-add-form] button[type=submit]');
      this.zrodloCeny = document.querySelector('[data-vk-price]');
      this.cena = this.querySelector('[data-vk-buybar-price]');
      this.przycisk = this.querySelector('[data-vk-buybar-add]');
      if (!this.cta || !this.realny || !this.przycisk) return;

      this.przycisk.addEventListener('click', () => {
        // Klik, a nie submit: form może mieć własną obsługę zdarzenia.
        this.realny.click();
      });

      this.przepisz();

      if (this.zrodloCeny) {
        this.obsCeny = new MutationObserver(() => this.przepisz());
        this.obsCeny.observe(this.zrodloCeny, { childList: true, subtree: true, characterData: true });
      }
      this.obsPrzycisku = new MutationObserver(() => this.przepisz());
      this.obsPrzycisku.observe(this.realny, { attributes: true, childList: true, subtree: true });

      // Pasek wjeżdża dopiero, gdy klient MINIE przycisk zakupu, a nie gdy
      // ten jest jeszcze przed nim. Bez tego rozróżnienia pasek pojawiałby się
      // od razu po wejściu na stronę — zanim ktokolwiek zobaczył produkt —
      // bo na telefonie przycisk leży poniżej pierwszego ekranu.
      if ('IntersectionObserver' in window) {
        this.obsWidoku = new IntersectionObserver((wpisy) => {
          const w = wpisy[0];
          const minięty = w.boundingClientRect.top < 0;
          this.hidden = w.isIntersecting || !minięty;
        }, { threshold: 0 });
        this.obsWidoku.observe(this.cta);
      } else {
        this.hidden = true;
      }
    }

    disconnectedCallback() {
      [this.obsCeny, this.obsPrzycisku, this.obsWidoku].forEach((o) => o && o.disconnect());
    }

    przepisz() {
      if (this.cena && this.zrodloCeny) {
        const teraz = this.zrodloCeny.querySelector('.vk-price__now');
        this.cena.textContent = teraz ? teraz.textContent.trim() : '';
      }
      const niedostepny = this.realny.getAttribute('aria-disabled') === 'true' || this.realny.disabled;
      this.przycisk.setAttribute('aria-disabled', niedostepny ? 'true' : 'false');
      this.przycisk.disabled = !!niedostepny;
      const napis = this.realny.querySelector('span');
      if (napis && niedostepny) this.przycisk.textContent = napis.textContent.trim();
    }
  }

  if (!window.customElements.get('vk-buybar')) {
    window.customElements.define('vk-buybar', VkBuybar);
  }
})();
